/**
 * An extra-small shadow.
 *
 * Reference shadow on default theme:
 *
 * - Blur: `2px`, offsetX: `0px`, offsetY: `1px`, color: `{shadow}`
 * - Blur: `1px`, offsetX: `0px`, offsetY: `0px`, color: `{shadow}`
 */
export const xsmall = 'var(--cb-shadow-xsmall)';

/**
 * A small shadow.
 *
 * Reference shadow on default theme:
 *
 * - Blur: `8px`, offsetX: `0px`, offsetY: `2px`, color: `{shadow}`
 * - Blur: `2px`, offsetX: `0px`, offsetY: `1px`, color: `{shadow}`
 * - Blur: `1px`, offsetX: `0px`, offsetY: `0px`, color: `{shadow}`
 */
export const small = 'var(--cb-shadow-small)';

/**
 * A medium shadow.
 *
 * Reference shadow on default theme:
 *
 * - Blur: `12px`, offsetX: `0px`, offsetY: `4px`, color: `{shadow}`
 * - Blur: `2px`, offsetX: `0px`, offsetY: `1px`, color: `{shadow}`
 * - Blur: `1px`, offsetX: `0px`, offsetY: `0px`, color: `{shadow}`
 */
export const medium = 'var(--cb-shadow-medium)';

/**
 * A large shadow.
 *
 * Reference shadow on default theme:
 *
 * - Blur: `28px`, offsetX: `0px`, offsetY: `8px`, color: `{shadow}`
 * - Blur: `6px`, offsetX: `0px`, offsetY: `2px`, color: `{shadow}`
 * - Blur: `1px`, offsetX: `0px`, offsetY: `0px`, color: `{shadow}`
 */
export const large = 'var(--cb-shadow-large)';
